// src/components/quizzes/BonusPlaneMode.js
//
// The original of the four, and the only one whose art actually existed. Those
// Storage URLs are preserved verbatim in BonusSideScroller's `plane` theme, so
// this looks exactly as it did — it just picks up the countdown, the combo
// meter, the score floor, the memory-leak fix and the summary screen along
// with the other three.

import React from "react";
import BonusSideScroller from "./BonusSideScroller";

export default function BonusPlaneMode(props) {
  return <BonusSideScroller theme="plane" {...props} />;
}
